import SimpleListProductBox from './simpleListProductBox'

export default SimpleListProductBox
